// stores/donationStore.ts
import { makeAutoObservable, observable } from "mobx";
import api, {
  PostDonationParameters,
  GetDonationListParameters,
  PutDonationParameters,
  GetDonationRes,
  GetDonationListRes,
  PutDonationRes,
  PostDonationRes,
} from "../api";
import { createRequestStatus, handleRequest, handleLoadMoreRequest } from "../toll/toolRequestStatus";

class DonationStore {
  donationList: GetDonationRes[] = [];
  donationMap = observable.map<string, GetDonationRes>();
  donationListStatus = createRequestStatus();
  loadMoreStatus = createRequestStatus();
  donationStatusMap = observable.map<string, ReturnType<typeof createRequestStatus>>();
  donationStatusMapA: { [x: string]: ReturnType<typeof createRequestStatus> } = {}
  createDonationStatus = createRequestStatus();
  updateDonationStatus = createRequestStatus();
  total = 0;
  lastId?: string
  noMoreData = false;
  createDonationSuccess?: boolean
  updateDonationSuccess?: boolean
  createDonationData?: PostDonationRes
  updateDonationData?: PutDonationRes
  constructor () {
    makeAutoObservable(this);
  }

  getDonationList = async (params?: Partial<GetDonationListParameters>) => {
    this.resetDonationList();
    await handleRequest<GetDonationListRes>(
      this.donationListStatus,
      () => api.GetDonationList({ ...params }),
      (res) => {
        this.donationList = res?.items || [];
        this.total = res?.total || 0;
        this.lastId = res.items?.pop()?.id
      },
      "获取捐款记录列表失败"
    );
  };

  loadMoreDonation = async (params?: Partial<GetDonationListParameters>) => {
    if (!this.hasMore || this.loadMoreStatus.loading) return;
    await handleLoadMoreRequest<GetDonationRes, GetDonationListRes>({
      limit: params?.limit,
      lastId: this.lastId,
      dataList: this.donationList,
      setDataList: arr => { this.donationList = arr; },
      setTotal: n => { this.total = n; },
      statusObj: this.loadMoreStatus,
      apiCall: (limit, lastId) => api.GetDonationList({ limit, lastId }),
      onSuccess: (res) => {
        this.total = res?.total || 0;
        this.lastId = res.items?.pop()?.id
      },
      setNoMoreData: flag => { this.noMoreData = flag; },
      defaultErrMsg: "加载更多捐款失败",
    });
  };

  get hasMore() {
    return !this.noMoreData && this.donationList.length < this.total;
  }

  resetDonationList() {
    this.donationList = [];
    this.total = 0;
    this.lastId = undefined
    this.noMoreData = false
  }

  getDonation = async (donationId: string) => {
    if (!this.donationStatusMap.has(donationId)) {
      this.donationStatusMap.set(donationId, createRequestStatus());
    }
    const statusObj = this.donationStatusMap.get(donationId)!;
    await handleRequest<GetDonationRes>(
      statusObj,
      () => api.GetDonation({ id: donationId }),
      (res) => {
        this.donationMap.set(donationId, res);
      },
      "获取捐款详情失败"
    );
  };

  resetCreateDonation() {
    this.createDonationSuccess = false;
    this.createDonationData = undefined
  }

  resetUpdateDonation() {
    this.updateDonationSuccess = false;
    this.updateDonationData = undefined
  }

  createDonation = async (params: PostDonationParameters) => {
    await handleRequest<PostDonationRes>(
      this.createDonationStatus,
      () => api.PostDonation(params),
      (res) => {
        this.createDonationData = res
        this.createDonationSuccess = true;
      },
      "新增捐款失败"
    );
  };

  updateDonation = async (params: PutDonationParameters) => {
    await handleRequest<PutDonationRes>(
      this.updateDonationStatus,
      () => api.PutDonation(params),
      (res) => {
        this.updateDonationData = res
        this.updateDonationSuccess = true
      },
      "更新捐款失败"
    );
  };
}

const donationStore = new DonationStore();
export default donationStore;
